import useWebSocket from 'react-use-websocket';
import { useEffect, useState } from 'react';
import { TypeNotifications } from './typeNotifications.enum';

const WebSocketComponent = ({
    callbackMessage
}) => {
  const token = sessionStorage.getItem('token');// Get your token from local storage, context, etc.
  const server = process.env.REACT_APP_HOST_WS
  const socketUrl = `${server}ws`;

  const { sendMessage, lastMessage, readyState } = useWebSocket(
    socketUrl,
    {
      share: false, // Set to true if you want to share the same WebSocket instance across multiple components
      shouldReconnect: () => true, // Configure reconnection logic
    }
  );

  //AUTHENTICATION
  useEffect(() => {
    if (readyState === 1) { // ReadyState.OPEN
      const autentificationMessage = {type: TypeNotifications.AUTHENTICATION, message:'', data:{authorization:token.slice(1, -1)}}
      sendMessage(JSON.stringify(autentificationMessage));
    }
  }, [readyState]);

  //MESSAGE IMPUT
  useEffect(() => {
    if (lastMessage) {
       const message = JSON.parse(lastMessage.data)     
      if(message.notificationMessage.type === TypeNotifications.ACTIVITY_MAKE){
        callbackMessage(message.notificationMessage);
      }

      if(message.notificationMessage.type === TypeNotifications.GETMESSAGES){
        callbackMessage(message.notificationMessage);
      }
    }
  }, [lastMessage]);

  return (
    <div>
      {/* Your UI for sending/receiving messages */}
    </div>
  );
};

export default WebSocketComponent;